exports.install = function(Vue, options) {
  /**
   * 注意:  定义type 规则时 不用做非空验证
   *        只需要传入 required:true 和校验的类型比如change或者blur即可
   * */
  /* 验证QQ号码 */
  const isvalidateQQ = (rule, value, callback) => {
    if (value && value !== '') {
      const regEn = /^[1-9]\d*$/
      if (!regEn.test(value)) {
        callback(new Error('正整数'))
      } else {
        callback()
      }
    } else {
      callback()
    }
  }
  const cannotBeZero = (rule, value, callback) => {
    if (value === '0' || value === 0) {
      callback(new Error('此项数据不能为0'))
    } else {
      callback()
    }
  }
  const Contacts = (rule, value, callback) => {
    const t = /^([a-zA-Z]{1,20}|[a-zA-Z]{1,20}·[a-zA-Z]{1,20}|[\u4e00-\u9fa5]{2,20}|[\u4e00-\u9fa5]{1,20}·[\u4e00-\u9fa5]{1,20})$/
    if (!t.test(value)) {
      callback(new Error('请输入正确的联系人格式'))
    } else {
      callback()
    }
  }
  Vue.prototype.filter_rules = function(item) {
    const rules = []
    // 必填项校验
    if (item.required) {
      if (item.type === 'change') {
        rules.push({ required: true, message: '必填项不能为空!', trigger: 'change' })
      } else {
        rules.push({ required: true, message: '必填项不能为空!', trigger: 'blur' })
      }
    }
    // 自定义校验
    if (item.prop) {
      const prop = item.prop
      switch (prop) {
        case 'qq':
          rules.push({ validator: isvalidateQQ, trigger: 'blur' })
          break
        case 'ccContacts':
          rules.push({ validator: Contacts, trigger: 'blur' })
          break
        case 'cannotBeZero':
          rules.push({ validator: cannotBeZero, trigger: 'blur' })
          break
        default:
          rules.push({})
          break
      }
    }
    return rules
  }
}
